import { useMemo } from 'react';

import * as ui from '@april9au/stack9-ui';
import { Utils } from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';

const S9Button = ui.S9Button.default;
const S9ButtonLink = ui.S9ButtonLink.default;

export const ButtonLink = ({
  route,
  params,
  query,
  asButton = false,
  ...props
}: Omit<ui.S9Button.S9ButtonProps, 'href' | 'onClick'> & {
  route: AppRoutes;
  params?: Record<string, any>;
  query?: Record<string, any>;
  asButton?: boolean | null | undefined;
}) => {
  const href = useMemo(
    () => Utils.resolveRoute(route, params, query),
    [route, params, query],
  );

  if (asButton) {
    return <S9Button {...props} href={href} />;
  }

  return <S9ButtonLink {...props} href={href} />;
};
